import * as Yup from "yup";

export const projectCreationValidationSchema = Yup.object().shape({
  id: Yup.number().min(0).required("id is required"),
  companyCode: Yup.number().min(1).required("Company Code is required"),
  projectCode: Yup.string(), //.required("Project code is required"),
  projectName: Yup.string().required("Project name is required"),
  projectStartDay: Yup.string().required("Project start date is required"),
  projectEndDay: Yup.string().nullable(),
  projectStatus: Yup.string().required("Project status is required"),
  approvedBy: Yup.string().required("Approved by is required"),
  groupCode: Yup.string().nullable(),
  shiftCode: Yup.string().nullable(),
  createUser: Yup.string().required("createUser is required"),
  createDate: Yup.string().required("createDate is required"),
  modifyUser: Yup.string().required("modifyUser is required"),
  modifyDate: Yup.string().required("modifyDate is required"),
  isActive: Yup.bool().required("Select active status"),
  remarks: Yup.string().required("Remarks is required"),
  locationCode: Yup.string().nullable(),
  type: Yup.number().nullable(),
  department: Yup.number().nullable(),
  clientProjectCode: Yup.number().nullable(),
  team: Yup.string().nullable(),
  abbreviation: Yup.string().nullable(),
  projectDescription: Yup.string().required("Project Description is required"),
  clientDetails: Yup.object().shape({
    id: Yup.number().min(0).required("id is required"),
    companyCode: Yup.number().min(1).required("Company Code is required"),
    locationCode: Yup.string(),
    projectCode: Yup.string(),
    clientCompany: Yup.string().nullable(),
    mainContact: Yup.string().nullable(),
    contact2: Yup.string().nullable(),
    remarks: Yup.string().nullable(),
    clientProjectCode: Yup.number(),
    address: Yup.string().nullable(),
    email: Yup.string().email("Invalid email"),
    email2: Yup.string().email("Invalid email"),
    clientProjectAbbr: Yup.string().nullable(),
    isActive: Yup.bool(),
    createdBy: Yup.string().nullable(),
    createdDate: Yup.string().nullable(),
    modifiedBy: Yup.string().nullable(),
    modifiedDate: Yup.string().nullable(),
  }),
  approvalDetails: Yup.object().shape({
    id: Yup.number().min(0).required("id is required"),
    companyCode: Yup.number().min(1).required("Company Code is required"),
    locationCode: Yup.string().nullable(),
    projectCode: Yup.string().nullable(),
    modeOfApproval: Yup.string().nullable(),
    clientWORefNo: Yup.string().nullable(),
    clientContractNo: Yup.string().nullable(),
    attachWO: Yup.string().nullable(),
    workOrderMode: Yup.string().nullable(),
    hardcopyReceived: Yup.bool(),
    remarks: Yup.string().nullable(),
    technicalDetails: Yup.string().nullable(),
    latitude: Yup.number().typeError("Latitude must be number"),
    longitude: Yup.number().typeError("Longitude must be number"),
    commercialDetails: Yup.string().nullable(),
    quotationTemplate: Yup.string().nullable(),
    quoteKey: Yup.string().nullable(),
    minimumManday: Yup.number().typeError("Minimum Manday must be number"),
    estimatedManHours: Yup.number().typeError(
      "Estimated Man Hours must be number"
    ),
    estimatedManHourCost: Yup.number().typeError(
      "Estimated Man Hour Cost must be number"
    ),
    estimatedMaterialCost: Yup.number().typeError(
      "Estimated Material Cost must be number"
    ),
    isLoginAllLocations: Yup.bool().required(
      "Select Allow Login All Locations"
    ),
    locationRadius: Yup.number()
      .transform((value, originalValue) => {
        // When empty string → convert to null
        return originalValue === "" ? null : value;
      })
      .default(0)
      .nullable()
      .when("isLoginAllLocations", {
        is: true,
        then: (schema) =>
          schema
            .notRequired()
            .transform(() => 0) // force value = 0 when isLoginAllLocations = true
            .nullable(),
        otherwise: (schema) => schema.required("Location Radius is required"),
        // .min(1, "Minimum radius is 1")
        // .max(100, "Maximum radius is 100"),
      }),

    // locationRadius: Yup.number()
    //   .typeError("Location Radius is required 1 to 100")
    //   .default(0)
    //   .nullable()
    //   .when("isLoginAllLocations", (isLoginAllLocations, schema) =>
    //     isLoginAllLocations ? schema.notRequired() : schema.required("Location Radius is required")
    //   ),
    isActive: Yup.bool(),
    createdBy: Yup.string().nullable(),
    createdDate: Yup.string().nullable(),
    modifiedBy: Yup.string().nullable(),
    modifiedDate: Yup.string().nullable(),
  }),
  projectsDetails: Yup.array().of(
    Yup.object().shape({
      id: Yup.number().min(0).required("id is required"),
      companyCode: Yup.number().min(1).required("Company Code is required"),
      projectCode: Yup.string().nullable(),
      employeeCode: Yup.number(),
      createUser: Yup.string().nullable(),
      createDate: Yup.string().nullable(),
      modifyUser: Yup.string().nullable(),
      modifyDate: Yup.string().nullable(),
      isActive: Yup.bool(),
    })
  ),
});

export const projectCreationValidationSchemaOld = Yup.object().shape({
  id: Yup.number().min(0).required("id is required"),
  companyCode: Yup.number().min(1).required("Company Code is required"),
  projectCode: Yup.string(), //.required("Project code is required"),
  projectName: Yup.string().required("Project name is required"),
  projectStartDay: Yup.string().required("Project start date is required"),
  projectEndDay: Yup.string(), //.required("Project end date is required"),
  projectStatus: Yup.string().required("Project status is required"),
  approvedBy: Yup.string().required("Approved by is required"),
  remarks: Yup.string().required("Remarks is required"),
  // groupCode: Yup.string(), //.required("Group code is required"),
  // shiftCode: Yup.string(), //.required("Shift code is required"),
  createUser: Yup.string().required("createUser is required"),
  createDate: Yup.string().required("createDate is required"),
  modifyUser: Yup.string().required("modifyUser is required"),
  modifyDate: Yup.string().required("modifyDate is required"),
  isActive: Yup.bool().required("Select active status"),
  selectedEmployees: Yup.array()
    .of(Yup.number())
    .test(
      "Select alteast one employee",
      "At least one employee must be selected",
      (value) => {
        return value?.length > 0;
      }
    ),
});

export const jobCreationValidationSchema = Yup.object().shape({
  id: Yup.number().min(0).required("id is required"),
  companyCode: Yup.number().min(1).required("Company Code is required"),
  jobCode: Yup.string(), //.required("Job code is required"),
  jobTitle: Yup.string().required("Job name is required"),
  jobStartTime: Yup.string(), //.required("Job start time is required"),
  jobEndTime: Yup.string(), //.required("Job end time is required"),
  jobStartDate: Yup.string(), //.required("Job start time is required"),
  jobEndDate: Yup.string(), //.required("Job end time is required"),
  projectCode: Yup.string().required("Project code is required"),
  shiftCode: Yup.string().required("Shift code is required"),
  jobStatus: Yup.string().required("Job status is required"),
  priority: Yup.string().required("Job Priority is required"),
  assignedBy: Yup.string().required("select assigned By is required"),
  createUser: Yup.string().required("createUser is required"),
  createDate: Yup.string().required("createDate is required"),
  modifyUser: Yup.string().required("modifyUser is required"),
  modifyDate: Yup.string().required("modifyDate is required"),
  isActive: Yup.bool(),
  remarks: Yup.string().required("Remarks is required"),
  selectedEmployees: Yup.array()
    .of(Yup.number())
    .required("At least one employee must be selected")
    .min(1, "At least one employee must be selected"),
});
